"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var SHOP_TYPES = {
  B2B: "b2b",
  B2C: "b2c",
  MIXED: "mixed"
};
var _default = SHOP_TYPES;
exports.default = _default;